import { useEffect } from 'react';
import { usePromptStore } from './store';
import { useCurrentSpaceView } from 'src/hooks/space';
import { systemPromptData } from './data';

export const useFetchAIPrompt = () => {
  const spaceView = useCurrentSpaceView();
  useEffect(() => {
    if (!spaceView) return;
    //@ts-ignore type check
    const aiPromptData = spaceView.setting.aiPrompt ?? systemPromptData;
    // const aiPromptData = systemPromptData;
    //@ts-ignore type check
    usePromptStore.setState({
      editPrompts: aiPromptData.editPrompts,
      emptyWithPrompts: aiPromptData.emptyWithPrompts,
      records: aiPromptData.records,
      curentPromptId: aiPromptData.editPrompts[0]!,
    });
  }, [spaceView]);
};
